/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useMemo, useState } from "react";
import { Box, Typography, FormGroup, FormControlLabel, Checkbox } from "@mui/material";
import styled from "@emotion/styled";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Woman2OutlinedIcon from '@mui/icons-material/Woman2Outlined';
import Man2OutlinedIcon from '@mui/icons-material/Man2Outlined';
import SocialDistanceOutlinedIcon from '@mui/icons-material/SocialDistanceOutlined';
import Diversity3OutlinedIcon from '@mui/icons-material/Diversity3Outlined';
import SportsHandballOutlinedIcon from '@mui/icons-material/SportsHandballOutlined';
import TransgenderOutlinedIcon from '@mui/icons-material/TransgenderOutlined';
import en from '../../nls/en.json';
import { useSelector } from "react-redux";
import { isEmpty } from "../../utils/constants";
import { useLocation } from "react-router-dom";

const OptionsWrapper = styled.div`
  margin-top: -40px;
  .MuiFormControlLabel-root {
    background-color: #e7f4ff;
    border-radius: 5px;
    margin-right: 0;
    margin-bottom: 8px;
    position: relative;
    height: 46px;
    margin-left: 0;
    .MuiFormControlLabel-label {
      align-items:center;
      display: flex;
      z-index: 1;
      svg{
        color:#1468A2;
        margin-right:10px;
        width:20px;
        height:20px;
      }
    }
    .MuiCheckbox-root {
      svg{
        display:none;
      }
      &.Mui-checked {
        position: absolute;
        width: 100%;
        height: 100%;
        &::after {
          content: "";
          background-color: #1468a2;
          border-radius: 5px;
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
        }
        & + .MuiFormControlLabel-label {
          color: #fff;
          margin-left:18px;
          align-items: center;
          svg{
            color:#fff;
            margin-right:10px;
            path{fill:#fff}
          }
        }
      }
    }
  }
`;

const theme = createTheme({
  palette: {
    primary: {
      main: "#1468A2",
    },
  },
  typography: {
    fontFamily: ["Poppins, sans-serif"].join(","),
    variants: [],
  },
  components: {
    MuiButton: {
      styleOverrides: {
        // Name of the slot
        root: {
          fontSize: "1rem",
          padding: "9.2px 15px",
          textTransform: "none",
        },
      },
      variants: [
        {
          props: { variant: "contained" },
          style: {
            backgroundColor: "#1468A2",
            width: "240px",
            "&:hover": {
              backgroundColor: "#1468A2",
              color: "#fff",
            },
          },
        },
      ],
    },
  },
});
theme.typography.h2 = {
  fontSize: 28,
  fontWeight: 600,
  color: "#1468A2",
  lineHeight: "36px",
  marginBottom: "18px",
  position: "relative",
  top: "-110px",
  height: "72px",
  ["@media (max-width:767px)"]: { top: "-140px", },
};
theme.typography.h3 = {
  fontSize: 16,
  fontWeight: 500,
  color: "#666",
  marginBottom: "1rem",
};

const MentorGroup = ({ getGroup, data, isFromEditSection }) => {
  const location = useLocation();
  const mentorId = location?.state?.mentorId;
  const { savedAnswer, studentProfileIfo } = useSelector(({ studentInfoSlice }) => studentInfoSlice);
  const { BASIC_INFORMATION } = savedAnswer;
  const {MENTOR_BACKGROUND} = mentorId ? studentProfileIfo : savedAnswer;
  const defaultvals =  !isEmpty(MENTOR_BACKGROUND) && MENTOR_BACKGROUND?.find(item => item.sub_category_name === 'MENTOR_WHOS_SIMILAR_BACKGROUND_TO_YOU')?.options?.map(option => option?.option_id) || [];
  const dataArray = data?.data?.MENTOR_BACKGROUND?.find(item => item.sub_category_name === 'MENTOR_WHOS_SIMILAR_BACKGROUND_TO_YOU');
  
  const [SGroup, setSGroup] = useState(defaultvals);
  const handleCheckboxChange = (optionId) => {
    if (SGroup?.includes(optionId)) {
      setSGroup((prevSGroup) => prevSGroup.filter((id) => id !== optionId));
    } else {
      setSGroup((prevSGroup) => [...prevSGroup, optionId]);
    }
  };

  const changeColor = {
    fill: '#fff',
    marginRight: "10px"
  };

  const iconMap = {
    "Female": <Woman2OutlinedIcon fontSize="small" sx={{ mr: 1 }} />,
    "Male": <Man2OutlinedIcon fontSize="small" sx={{ mr: 1 }} />,
    "Transfer Student": <SocialDistanceOutlinedIcon fontSize="small" sx={{ mr: 1 }} />,
    "BIPOC": <Diversity3OutlinedIcon fontSize="small" sx={{ mr: 1 }} />,
    "Student Athlete": <SportsHandballOutlinedIcon fontSize="small" sx={{ mr: 1 }} />,
    "LGBTQ+": <TransgenderOutlinedIcon fontSize="small" sx={{ mr: 1 }} />,
    "Non-Binary": <svg xmlns="http://www.w3.org/2000/svg" width="9.97" height="14.955" viewBox="0 0 9.97 14.955">
      <path style={SGroup?.includes(44) ? changeColor : null} id="agender_FILL0_wght400_GRAD0_opsz24" d="M244.985-825.045a4.807,4.807,0,0,1-3.531-1.454A4.807,4.807,0,0,1,240-830.03a4.812,4.812,0,0,1,1.194-3.251,4.85,4.85,0,0,1,2.96-1.672V-840h1.662v5.047a4.819,4.819,0,0,1,2.97,1.672,4.837,4.837,0,0,1,1.184,3.251,4.807,4.807,0,0,1-1.454,3.531A4.807,4.807,0,0,1,244.985-825.045Zm0-1.662a3.181,3.181,0,0,0,2.046-.706A3.35,3.35,0,0,0,248.2-829.2h-6.439a3.35,3.35,0,0,0,1.174,1.786A3.181,3.181,0,0,0,244.985-826.707Zm-3.219-4.154H248.2a3.35,3.35,0,0,0-1.174-1.786,3.18,3.18,0,0,0-2.046-.706,3.18,3.18,0,0,0-2.046.706A3.35,3.35,0,0,0,241.765-830.861Z" transform="translate(-240 840)" fill="#1468a2" />
    </svg>,
    "First Generation College Student": <svg xmlns="http://www.w3.org/2000/svg" width="12.071" height="13.702" viewBox="0 0 12.071 13.702">
      <path style={SGroup?.includes(45) ? changeColor : null} id="editor_choice_FILL0_wght400_GRAD0_opsz24" d="M112.121-866.3v-5.367L110-875.106,113.018-880h6.035l3.018,4.894-2.121,3.442v5.367l-3.915-1.3Zm1.3-1.811,2.61-.865,2.61.865v-2.1h-5.22Zm.326-10.586-2.218,3.589,2.218,3.589h4.567l2.218-3.589-2.218-3.589Zm1.6,6.247-2.316-2.3.93-.93,1.387,1.386,2.757-2.773.93.913Zm-1.925,2.235h0Z" transform="translate(-110 880)" fill="#1468a2" />
    </svg>,
    "International Student": <svg xmlns="http://www.w3.org/2000/svg" width="13.842" height="13.842" viewBox="0 0 13.842 13.842">
      <path style={SGroup?.includes(50) ? changeColor : null} id="language_FILL0_wght300_GRAD0_opsz24" d="M106.922-846.157a6.7,6.7,0,0,1-2.686-.546,7.021,7.021,0,0,1-2.2-1.486,7.02,7.02,0,0,1-1.486-2.2,6.7,6.7,0,0,1-.546-2.686,6.688,6.688,0,0,1,.546-2.692,7.037,7.037,0,0,1,1.486-2.2,7.021,7.021,0,0,1,2.2-1.486,6.7,6.7,0,0,1,2.686-.546,6.688,6.688,0,0,1,2.692.546,7.039,7.039,0,0,1,2.2,1.486,7.037,7.037,0,0,1,1.486,2.2,6.688,6.688,0,0,1,.546,2.692,6.7,6.7,0,0,1-.546,2.686,7.02,7.02,0,0,1-1.486,2.2,7.039,7.039,0,0,1-2.2,1.486A6.688,6.688,0,0,1,106.922-846.157Zm0-1.108a9.963,9.963,0,0,0,.939-1.492,8.513,8.513,0,0,0,.621-1.645h-3.119a9.3,9.3,0,0,0,.628,1.673A8.541,8.541,0,0,0,106.922-847.266Zm-1.411-.2a7.9,7.9,0,0,1-.752-1.367,8.939,8.939,0,0,1-.518-1.57h-2.471a5.71,5.71,0,0,0,1.548,1.907A5.2,5.2,0,0,0,105.511-847.466Zm2.822,0a5.2,5.2,0,0,0,2.194-1.03,5.71,5.71,0,0,0,1.548-1.907H109.6a11.451,11.451,0,0,1-.553,1.577,9.477,9.477,0,0,1-.717,1.36Zm-7.022-4.029h2.708q-.069-.406-.1-.8t-.031-.787q0-.4.031-.787t.1-.8h-2.708a5.76,5.76,0,0,0-.161.772,5.847,5.847,0,0,0-.056.811,5.849,5.849,0,0,0,.056.811A5.765,5.765,0,0,0,101.311-851.5Zm3.8,0h3.62q.069-.406.1-.789t.031-.794q0-.411-.031-.794t-.1-.79h-3.62q-.069.406-.1.79t-.031.794q0,.411.031.794T105.112-851.5Zm4.713,0h2.708a5.767,5.767,0,0,0,.161-.772,5.849,5.849,0,0,0,.056-.811,5.848,5.848,0,0,0-.056-.811,5.763,5.763,0,0,0-.161-.772h-2.708q.069.406.1.8t.031.787q0,.4-.031.787T109.825-851.5Zm-.221-4.259h2.471a5.7,5.7,0,0,0-1.538-1.907,5.365,5.365,0,0,0-2.2-1.037,9.052,9.052,0,0,1,.745,1.391A10.025,10.025,0,0,1,109.6-855.754Zm-4.241,0h3.119a9.36,9.36,0,0,0-.638-1.683,8.507,8.507,0,0,0-.921-1.453,8.509,8.509,0,0,0-.921,1.453A9.362,9.362,0,0,0,105.362-855.754Zm-3.593,0h2.471a10.024,10.024,0,0,1,.525-1.552,9.05,9.05,0,0,1,.745-1.391,5.312,5.312,0,0,0-2.208,1.04A5.773,5.773,0,0,0,101.769-855.754Z" transform="translate(-100.001 859.999)" fill="#1468a2" />
    </svg>,
    "Immigrant Student": <svg xmlns="http://www.w3.org/2000/svg" width="17.682" height="15.914" viewBox="0 0 17.682 15.914">
      <path style={SGroup?.includes(49) ? changeColor : null} id="social_distance_FILL0_wght400_GRAD0_opsz24" d="M83.537-824.086,80-827.622l3.537-3.536,1.238,1.238-1.415,1.415H94.323l-1.415-1.415,1.238-1.238,3.536,3.536-3.536,3.536-1.238-1.238,1.415-1.415H83.36l1.415,1.415ZM80-832.927v-.508a1.748,1.748,0,0,1,.287-.973,1.762,1.762,0,0,1,.8-.663,6.692,6.692,0,0,1,1.183-.376,5.949,5.949,0,0,1,1.271-.133,5.95,5.95,0,0,1,1.271.133,6.692,6.692,0,0,1,1.183.376,1.762,1.762,0,0,1,.8.663,1.748,1.748,0,0,1,.287.973v.508Zm10.61,0v-.508a1.748,1.748,0,0,1,.287-.973,1.762,1.762,0,0,1,.8-.663,6.692,6.692,0,0,1,1.183-.376,5.95,5.95,0,0,1,1.271-.133,5.949,5.949,0,0,1,1.271.133,6.692,6.692,0,0,1,1.183.376,1.762,1.762,0,0,1,.8.663,1.748,1.748,0,0,1,.287.973v.508Zm-7.073-3.537a1.7,1.7,0,0,1-1.249-.519,1.7,1.7,0,0,1-.519-1.249,1.7,1.7,0,0,1,.519-1.249A1.7,1.7,0,0,1,83.537-840a1.7,1.7,0,0,1,1.249.519,1.7,1.7,0,0,1,.519,1.249,1.7,1.7,0,0,1-.519,1.249A1.7,1.7,0,0,1,83.537-836.464Zm10.609,0a1.7,1.7,0,0,1-1.249-.519,1.7,1.7,0,0,1-.519-1.249,1.7,1.7,0,0,1,.519-1.249A1.7,1.7,0,0,1,94.146-840a1.7,1.7,0,0,1,1.249.519,1.7,1.7,0,0,1,.519,1.249,1.7,1.7,0,0,1-.519,1.249A1.7,1.7,0,0,1,94.146-836.464Z" transform="translate(-80 840)" fill="#1468a2" />
    </svg>
  }

  useMemo(() => { getGroup(SGroup) }, [SGroup]);
  
  return (
    <ThemeProvider theme={theme}>
      <Box>
        <Box variant="form">
          {
            !isFromEditSection &&
            <Typography variant="h2">
              {en?.GREAT_TEXT}
            </Typography>
          }
          <OptionsWrapper>
            <Typography variant="h3" sx={{ mb: 0 }}>
              {dataArray && dataArray?.question_text}<span style={{ color: "#DC3545" }}>*</span>
            </Typography>
            <Typography variant="body2" sx={{ mb: 0, fontStyle: "italic", color: "#6C757D" }}>
              {en.MENTOR_ONBOARD_DEMOGRAPHIC_NOTE}
            </Typography>
            {BASIC_INFORMATION?.role_name === 'Mentor' ? null :
              <Typography
                variant="body2"
                sx={{ fontSize: "12px", color: "#666666" }}
              >
                {en.SELECT_ALL}
              </Typography>
            }
            <FormGroup sx={{ mt: 2 }}>
              {dataArray && dataArray?.options?.map((option) => (
                <FormControlLabel
                  key={option?.option_id}
                  control={<Checkbox
                    checked={SGroup?.includes(option?.option_id)}
                    onChange={() => handleCheckboxChange(option?.option_id)}
                  />}
                  label={
                    <React.Fragment>
                      {iconMap[option?.option_text]}
                      {option?.option_text}
                    </React.Fragment>
                  }
                />
              ))}
            </FormGroup>
          </OptionsWrapper>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default MentorGroup;
